/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const formSubmissionAnswerDataSchema = z.object({
	questionId: z.string().uuid(),
	answer: z.array(z.string()).nullable().optional(),
})

export type FormSubmissionAnswerDataSchema = z.infer<typeof formSubmissionAnswerDataSchema>
